import React from 'react';
import { clsx } from 'clsx';
import styles from './CalculatorTabs.module.scss';

export interface CalculatorTabsProps {
  activeTab: 'credit-line' | 'installment';
  onTabChange: (tab: 'credit-line' | 'installment') => void;
  className?: string;
}

export const CalculatorTabs: React.FC<CalculatorTabsProps> = ({
  activeTab,
  onTabChange,
  className,
}) => {
  return (
    <div className={clsx(styles.tabsContainer, className)}>
      <button
        className={clsx(styles.tab, {
          [styles.active]: activeTab === 'credit-line',
        })}
        onClick={() => onTabChange('credit-line')}
      >
        <span className={styles.tabText}>Linie de credit</span>
      </button>

      <button
        className={clsx(styles.tab, {
          [styles.active]: activeTab === 'installment',
        })}
        onClick={() => onTabChange('installment')}
      >
        <span className={styles.tabText}>Credit în rate</span>
      </button>
    </div>
  );
};
